import { ReactComponent as FacebookIcon } from '../../assets/icons/facebook.svg';
import { ReactComponent as TwitterIcon } from '../../assets/icons/twitter 1.svg';
import { ReactComponent as InstagramIcon } from '../../assets/icons/instagram.svg';
import useSubdomain from '../../utils/useSubdomain';

const socialMedia = [
  { name: 'facebook', Icon: FacebookIcon },
  { name: 'instagram', Icon: InstagramIcon },
  { name: 'twitter', Icon: TwitterIcon },
];

const SocialIcons = ({ className }: { className?: string }) => {
  const { config } = useSubdomain();
  const socialLinks = config.socialMediaLinks;

  return (
    <div className={className}>
      {socialMedia.map(({ name, Icon }) => {
        const href = socialLinks[name as keyof typeof socialLinks];

        return (
          <a
            key={name}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon className="w-5 h-5 hover:opacity-80 transition" />
          </a>
        );
      })}
    </div>
  );
};

export default SocialIcons;
